import css from './Slider.css'
import { fireEvent, toggleClass, jsFadeIn, jsFadeOut, hide, show } from '../../lib/jsfunc.js'
import { on, ready, query, queryAll } from '../../lib/dom.js'

var timeout = false;
var running = false;

var effectTimeout = 9000;
var effectDuration = 2000;

ready(function(){
  if(query('.SliderArea')){
    on('click', '.SliderFooter .slider-status .icons-circle-white', toggle);
    setTimeout(function() { next(query('.SliderArea')); }, effectTimeout);
  }
})

function next(area) {
  var showToggle, hideToggle, showHandle, nextToggle;

  clearTimeout(timeout);

  hideToggle = query(area, '.icons-dot-white');
  if(hideToggle){
    showHandle = hideToggle.getAttribute('data-next');
 
    nextToggle = query(area, '.slider-status > div[data-handle="'+showHandle+'"]');
    fireEvent(nextToggle, 'click');
  }
}

function toggle() {
  var area, showToggle, hideToggle, showItem, hideItem, showHandle, hideHandle;
  clearTimeout(timeout);
  if (running) return;
  running = true;

  area = this.closest('.SliderArea');
  showToggle = this;
  hideToggle = query(this.closest('.slider-status'), '.icons-dot-white');

  showHandle = showToggle.getAttribute('data-handle');
  hideHandle = hideToggle.getAttribute('data-handle');
  showItem = query(area, ':scope > div[data-handle="'+showHandle+'"]');
  hideItem = query(area, ':scope > div[data-handle="'+hideHandle+'"]');
  toggleClass(hideToggle, 'icons-circle-white');
  toggleClass(hideToggle, 'icons-dot-white');
  toggleClass(hideToggle, 'pointer');
  
  toggleClass(showToggle, 'icons-circle-white');
  toggleClass(showToggle, 'icons-dot-white');
  toggleClass(showToggle, 'pointer');
  
  /*jsFadeIn(showItem);
  jsFadeOut(hideItem);*/
  show(showItem);
  hide(hideItem);
  
  running = false;
  timeout = setTimeout(function() { next(area); }, effectTimeout);
}